module.exports = __webpack_public_path__ + "static/img/yaoqingye.5e3c06b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yaoqingye.png
// module id = l3jG
// module chunks = 1